<template>
  <bm-number-q
    v-bind="$attrs"
    :value.sync="internalConvertedValue"
    :suffix="unitPreference.suffix"
    :max-decimal-places="maxDecimalPlaces ?? unitPreference.maxDecimalPlaces"
    :placeholder="placeholderText"
    @blur="onBlur"
  />
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import {
  tenantService,
  type UnitDisplayPreference,
} from "@/app/services/extensions/tenantServiceExtended";

interface BmUnitBaseProps {
  value?: number | null;
  unitPreference: UnitDisplayPreference<any>;
  maxDecimalPlaces?: number;
  placeholderValue?: number | null;
}

interface BmUnitBaseEvents {
  (event: "update:value", value: number | null): void;
}

const props = withDefaults(defineProps<BmUnitBaseProps>(), {
  value: null,
  maxDecimalPlaces: undefined,
  placeholderValue: null,
});

const emit = defineEmits<BmUnitBaseEvents>();

const internalConvertedValue = ref<number | null>(null);

const placeholderText = computed(() =>
  props.placeholderValue === null
    ? null
    : tenantService
        .roundNumber(
          props.placeholderValue *
            props.unitPreference.conversionMultiplierFromBaseUnit
        )
        .toString()
);

watch(
  () => props.value,
  () => {
    internalConvertedValue.value =
      props.value !== null
        ? props.value * props.unitPreference.conversionMultiplierFromBaseUnit
        : null;
  },
  { immediate: true }
);

const onBlur = () => {
  // Use on blur to prevent updating value when user is inputting
  emit(
    "update:value",
    internalConvertedValue.value !== null
      ? internalConvertedValue.value /
          props.unitPreference.conversionMultiplierFromBaseUnit
      : null
  );
};
</script>
